<template>
  <div id="layoutInput" class="menuSection">
    <h2 class="optionTitle">{{ $t('selectLayout') }}</h2>
    <div class="optionInput oi-layout">
      <div>
        <input
          type="radio"
          :id="'layout-classic-svg'"
          class="hidden"
          name="layout"
          :value="'classic-svg'"
          :checked="posterLayout == 'classic-svg'"
          @change="$emit('change', $event.target.value)"
        />
        <label :for="'layout-classic-svg'" class="inputLabel">
          <p class="inputName">{{ $t('layout.classic-svg') }}</p>
          <div class="radiobox"></div>
        </label>
      </div>

      <div>
        <input
          type="radio"
          :id="'layout-straight-svg'"
          class="hidden"
          name="layout"
          :value="'straight-svg'"
          :checked="posterLayout == 'straight-svg'"
          @change="$emit('change', $event.target.value)"
        />
        <label :for="'layout-straight-svg'" class="inputLabel">
          <p class="inputName">{{ $t('layout.straight-svg') }}</p>
          <div class="radiobox"></div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutSelector',
  model: {
    prop: 'posterLayout',
    event: 'change',
  },
  props: {
    posterLayout: String,
  },
}
</script>
